import React, { FC } from 'react';
import { Form } from 'antd';
import { WrappedFormUtils } from 'antd/lib/form/Form';
import { Input } from '../../../system/components/Input';

interface Props {
  form: WrappedFormUtils;
  initialValue?: string;
}

export const InputGroupKey: FC<Props> = ({ form, initialValue }): JSX.Element => (
  <Form.Item label="Grouping Key">
    {form.getFieldDecorator('groupKey', {
      initialValue,
      rules: [{ required: false }],
    })(<Input allowClear placeholder="Grouping Key" />)}
  </Form.Item>
);
